"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPRequestConfig = void 0;
var helpers_1 = require("../../URI/helpers");
var utils_1 = require("../utils");
var HTTPRequestConfig = /** @class */ (function () {
    function HTTPRequestConfig(params) {
        this.model = params.model;
        this.bodyAsEncodeString = params.bodyAsEncodeString;
        this.transformBodyToLegacyString = params.transformBodyToLegacyString;
        this.requestType = params.model.requestType || (params.bodyAsEncodeString ? 'string' : 'json');
        this._withCredentials = params.withCredentials;
        this.url = params.url;
        this.headers = params.headers;
    }
    Object.defineProperty(HTTPRequestConfig.prototype, "body", {
        get: function () {
            var _a = this.model, parameters = _a.parameters, method = _a.method;
            if (!parameters || method === 'GET') {
                return undefined;
            }
            if (!this._cachedBody) {
                switch (this.requestType) {
                    case 'json':
                        this._cachedBody = JSON.stringify(parameters);
                        break;
                    case 'string':
                        if (this.bodyAsEncodeString) {
                            this._cachedBody = (0, helpers_1.transformObjectToQuery)(parameters, this.transformBodyToLegacyString);
                        }
                        else {
                            this._cachedBody = parameters;
                        }
                        break;
                    case 'formData':
                        this._cachedBody = (0, utils_1.convertObjectToFormData)(parameters);
                        break;
                    default:
                        this._cachedBody = parameters;
                }
            }
            return this._cachedBody;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTTPRequestConfig.prototype, "method", {
        get: function () {
            return this.model.method;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTTPRequestConfig.prototype, "withCredentials", {
        get: function () {
            if (this.model.apiType === 'external') {
                return this._withCredentials;
            }
            return typeof this._withCredentials === 'undefined' || !!this._withCredentials;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTTPRequestConfig.prototype, "isExternal", {
        get: function () {
            return this.model.apiType === 'external';
        },
        enumerable: false,
        configurable: true
    });
    return HTTPRequestConfig;
}());
exports.HTTPRequestConfig = HTTPRequestConfig;
//# sourceMappingURL=HTTPRequestConfig.js.map